import api from '~/api';
import { PaymentMethodsResponse } from '../dtos/bankAccountResponse';
import { BankAccount } from '../models/BankAccount';
import { capitalize } from '@hourly/utilities';

export async function getBankAccount(partnerId: string): Promise<BankAccount> {
  const { data } = await api.get<PaymentMethodsResponse>(`v1/payment_method/partner/${partnerId}`);

  const bankAccount = data.partner_payment_methods[0];

  return new BankAccount(
    bankAccount.bank_name,
    capitalize(bankAccount.bank_account_type),
    bankAccount.bank_account_number
  );
}
